export interface AppConfig {
  readonly apiBaseUrl: string;
  readonly vueIdpProfileSettingsUrl: string;
  readonly vueBuildVersion: string;
  readonly jupyterliteUrl?: string;
}

export type RuntimeAppConfig = Partial<AppConfig>;

const baked: AppConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  vueIdpProfileSettingsUrl: import.meta.env.VITE_VUE_IDP_PROFILE_SETTINGS_URL,
  vueBuildVersion: import.meta.env.VITE_VUE_BUILD_VERSION,
  jupyterliteUrl: import.meta.env.VITE_JUPYTERLITE_URL,
};

const runtime: RuntimeAppConfig = window.__APP_CONFIG__ ?? {};

export const config: AppConfig = { ...baked, ...runtime };
